import React, { useEffect, useState } from "react";
import { DecompositionTreeGraph } from "@ant-design/graphs";
import { useLocation, useParams } from "react-router-dom";
import PageLoader from "../sub/PageLoader";
import GetSplitsTreeApi from "../../api/plans/GetSplitsTreeApi";
import GetPlanTemplateByIdApi from "../../api/plan-templates/GetPlanTemplateByIdApi";
import { useSelector } from "react-redux";
import SplitPlanTreeInfoModal from "../modal/info/SplitPlanTreeInfoModal";

const SplitsTree = (props) => {
  const [canStart, setCanStart] = useState(false);
  const [planModal, setPlanModal] = useState(false);
  const [data, setData] = useState([]);
  const [levels, setLevels] = useState();
  const [planId, setPlanId] = useState("");
  const perfCycleState = useSelector((state) => state.perfCycleState.value);

  const { id } = useParams();

  useEffect(() => {
    getTreeData();
    getPlanLevels();
  }, []);

  async function getTreeData() {
    const apiResponse = await GetSplitsTreeApi(id);
    if (apiResponse.message === "success") {
      setData(apiResponse.data);
      setCanStart(true);
    }
  }

  async function getPlanLevels() {
    const apiResponse = await GetPlanTemplateByIdApi(perfCycleState?.template);
    if (apiResponse.success) {
      setLevels(apiResponse.data?.planLevels);
    }
  }

  function getNodeColor(node) {
    let nodeColor = "#91d5ff";
    levels?.forEach((level) => {
      if (level.id === node.levelId) {
        nodeColor = level.color;
      }
    });
    return nodeColor;
  }

  const config = {
    data,
    nodeCfg: {
      style: (node) => {
        return {
          stroke: getNodeColor(node),
          cursor: "pointer",
        };
      },
      label: {
        style: {
          cursor: "pointer",
        },
      },
      title: {
        containerStyle: (node) => {
          return {
            fill: getNodeColor(node),
            cursor: "pointer",
          };
        },
      },
      size: [180, 50],
    },
    edgeCfg: {
      type: "polyline",
    },
    behaviors: ["drag-canvas", "zoom-canvas", "drag-node"],
    autoFit: false,
  };

  return canStart ? (
    <>
      <div className="border">
        <DecompositionTreeGraph
          {...config}
          onReady={(graph) => {
            graph.on("node:click", (evt) => {
              setPlanId(evt.item._cfg.id);
              setPlanModal(true);
            });
          }}
        />
      </div>
      <SplitPlanTreeInfoModal
        visible={planModal}
        handleCancel={() => {
          setPlanModal(false);
          setPlanId("");
        }}
        planId={planId}
      />
    </>
  ) : (
    <PageLoader />
  );
};

export default SplitsTree;
